module.exports = __webpack_public_path__ + "static/media/S2P6_mutations.4e05f307.mp3";